<template>
	<v-row no-gutters>
		<v-col cols="3">
			<small>
				{{ $t("Code") }}
			</small>
			<p class="pt-2 font-weight-medium">#{{ reservation.code }}</p>
		</v-col>
		<v-col cols="3">
			<small>
				{{ $t("Datetime") }}
			</small>
			<p class="pt-2 font-weight-medium">
				{{ reservation.date }} @
				{{ reservation.time }}
			</p>
		</v-col>
		<v-col cols="3">
			<small>
				{{ $t("Customer") }}
			</small>
			<p class="pt-2 font-weight-medium">
				{{
					reservation.customer_name ? reservation.customer_name : null
				}}
			</p>
		</v-col>
		<v-col cols="3">
			<small>
				{{ $t("Outlet") }}
			</small>
			<p class="pt-2 font-weight-medium">
				{{ reservation.outlet_name ? reservation.outlet_name : null }}
			</p>
		</v-col>
		<!-- <v-col cols="2">
			<small>
				{{ $t("Amount") }}
			</small>
			<p class="pt-2 font-weight-medium">
				{{ reservation.total }}
				<v-btn color="black" dark x-small>{{
					reservation.payment_method_code
				}}</v-btn>
			</p>
		</v-col> -->
		<v-col cols="12" v-if="open">
			<v-divider></v-divider>
		</v-col>
	</v-row>
</template>

<script>
export default {
	props: ["reservation", "open"],
};
</script>